export default {"src":"/_next/static/media/welcome.colour.7802d494.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};